/**
 *  widgetConfigName: Default widget id value
 *
 *  widgetConfigOpts: Default widget opts
 *
 *  widgetConfigDestination: Destination where this widget image will be added
 *
 *  widgetConfigContainerClass: Custom class name for this widget
 */

export default function managedBackground({
  widgetConfigName,
  widgetConfigOpts,
  widgetConfigDestination,
  widgetConfigContainerClass,
}) {
  const widgetName = widgetConfigName;
  const widgetOpts = widgetConfigOpts;
  const $widgetElement = $(`#${widgetName}`);
  const mainFeatureElement = widgetConfigDestination;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,

    cardWidgetLoaded: function (data, _owl, hasData) {
      $widgetElement.remove();
      if (hasData) {
        $(`${mainFeatureElement}`).prepend(`<div class="${widgetConfigContainerClass}"></div>`);
        addCustomBackground(data.items[0], mainFeatureElement);
      }
      $(`${mainFeatureElement} .${widgetConfigContainerClass}`).addClass('show-bg');
    },
  });

  function addCustomBackground(widgetData, featureTarget) {
    const { ImageWithPath } = widgetData;

    $(`${featureTarget} .${widgetConfigContainerClass}`).css({
      'background-image': `url('${ImageWithPath}')`,
    });
  }
}
